import { siteRoot } from "@/helpers/siteRoot";

export default {
    data() {
        return {
            DEF_IMAGE: 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        }
    },
    methods: {
        getImageByModel(model, domElementID) {
            const getFieldNameByObject = object => { // model.constructor.name - не работает!
                if (object instanceof TaskModel) {
                    return 'photo_1';
                }
                if (object instanceof UserModel) {
                    return 'avatar';
                }
                return 'value;'
            };
            const imgField = getFieldNameByObject(model);

            const imgData = imgField ? model[imgField] : '';
            if (!imgData) { // Пока нет картинки, показываем дефолтную
                return this.DEF_IMAGE;
            }
            if (imgData.includes('data:image')) { // Это base64 картинка
                return imgData;
            }
            if (imgData.includes('ref_')) { // Это ссылка на карту в IndexedDB
                if (!domElementID) {
                    return;
                }
                setTimeout( async () => {
                    const base64image = await model[`${imgField}__byRef`];
                    const domElement = document.getElementById(domElementID);
                    domElement.src = base64image;
                }, 0);
                return this.DEF_IMAGE;
            }
            return siteRoot(imgData);
        }
    }
}